<template>
  <v-layout column>
    <v-flex>
      <sub-header :subHeaderConfig="subHeaderConfig" />
    </v-flex>
    <v-flex>
      <v-container fluid class="main-content-ctr">
        <v-flex id="noSubbrandCnr" md12 lg12 mt-5>
          <v-flex md4 lg4 ml-0>
            <v-spacer></v-spacer>
          </v-flex>
          <v-flex md4 lg4>
            <p
              autoid="lbl-default-content-first-time-login"
              class="text-lg-center no-subbrand-text"
            >No Sub-brands have been created</p>
            <p autoid="btn-create-sub-brand" class="text-lg-center no-subbrand-subtext">
              To add a new sub-brand, use
              <a @click="createSubbrand">Create Sub-brand</a> button
            </p>
          </v-flex>
          <v-flex md4 lg4>
            <v-spacer></v-spacer>
          </v-flex>
        </v-flex>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import SubHeader from '../../components/subheader.vue'
export default {
  components: {
    'sub-header': SubHeader
  },
  computed: {
    subHeaderConfig() {
      let config = {
        headerText: this.$lang.messages.sub_brands,
        subBrandCount: 0,
        actions: [
          {
            displayName: this.$lang.messages.create_sub_brand,
            autoid: 'create-subbrand-btn',
            controlName: 'button',
            actionType: 'primary',
            actionLink: {
              name: 'createSubbrand',
              params: {
                isEdit: false,
                backLink: '/dataloader',
                backText: this.$lang.messages.back_to_sub_brands_list
              }
            }
          }
        ]
      }
      return config
    }
  },
  methods: {
    createSubbrand() {
      this.$router.push({
        name: 'createSubbrand',
        params: {
          backLink: this.$router.history.current.path,
          backText: this.$lang.messages.back_to_sub_brands_list
        }
      })
    }
  },
  created() {}
}
</script>

<style lang="scss">
#noSubbrandCnr {
  display: flex;
  margin-top: 104px;
  .no-subbrand-text {
    font-size: 26px;
    line-height: 34px;
    color: #666666;
  }
  .no-subbrand-subtext {
    font-size: 12px;
    line-height: 14px;
    color: #666666;
  }
}
</style>
